<script setup>
import { ref } from 'vue'

import { useAccountingStore } from '@/stores/accounting.store'

import GridDetailTabs from '@/components/shared/GridDetailTabs.vue'
import CostReportRowsGrid from '@/components/accounting/CostReportRowsGrid.vue'
import MyExpensesGrid from '@/components/accounting/MyExpensesGrid.vue'

const props = defineProps({
  project: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['row-saved'])

const { costReportRowTypeEnum } = useAccountingStore()

const timeTab = 'time'
const expensesTab = 'expenses'
const activeTab = ref(timeTab)
</script>
<template>
  <grid-detail-tabs v-model="activeTab">
    <template #tabs>
      <q-tab :name="timeTab" :label="$t('common.costReportTime')" />
      <q-tab :name="expensesTab" :label="$t('common.projectExpenses')" />
    </template>
    <template #panels>
      <q-tab-panel :name="timeTab" class="q-pa-none">
        <cost-report-rows-grid
          :project="props.project"
          :types="[costReportRowTypeEnum.TIME]"
          @row-saved="emit('row-saved', props.project.id)"
        />
      </q-tab-panel>
      <q-tab-panel :name="expensesTab" class="q-pa-none">
        <my-expenses-grid :project="props.project" @row-saved="emit('row-saved', props.project.id)" />
      </q-tab-panel>
    </template>
  </grid-detail-tabs>
</template>
